import React, { useState, useEffect } from 'react';
import ViewLawyer from './index.js';
import { connect } from 'react-redux';
import { laywerUserById } from "../../store/actions/LaywerUserAction";
import { showLoading, hideLoading } from "../../store/actions/LoadingActions";
import ScrollToTopOnMount from '../ScrollToTopOnMount';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../routes';

const ViewProfileContainer = (props) => {
    const uid = props.match.params.uid;
    const item = props.location.state
    const [ didRender, setDidRender ] = useState(false)
    const history = useHistory()

    useEffect(() => {
        if (!didRender) {
            fetchMyAPI();
            setDidRender(true)
        }
    }, [didRender, props]);

    async function fetchMyAPI() {
        if (item === undefined) {
            try {
                props.showLoading()
                await props.laywerUserById(uid);    
            } catch (error) {
                history.push(ROUTES.ERROR_404)
            }
        }
        props.hideLoading()
    }

    return (
        <>
            {props.laywerById || item ?
            <>
                <ScrollToTopOnMount />
                <ViewLawyer key={item !== undefined ? item.id : props.laywerById.uid} user={item !== undefined ? item : props.laywerById} />
            </> : null
            }
            {/* {!this.state.loading && viewProfile && viewProfile} */}
        </>
    );
}
const mapStateToProps = (state) => ({
    laywerById: state.paginationReducer.laywerById
});

const mapDispatchToProps = dispatch => ({
    laywerUserById: (uid) => dispatch(laywerUserById(uid)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProfileContainer);